import {
    IReferenceSoilPropertyModel,
    IReferenceEstimationMethodModel,
    IReferenceExtReferenctModel
} from '../../util/Request/requestType';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '..';

interface soilAnalysesModel {
    soilPropertyList: IReferenceSoilPropertyModel[],
    methodList: IReferenceEstimationMethodModel[],
    extList: IReferenceExtReferenctModel[]
    soilAnalysisList: any[]
}
const initialState: soilAnalysesModel = {
    soilPropertyList: [],
    methodList: [],
    extList: [],
    soilAnalysisList: []
};
export const soilAnalyses = createSlice({
    name: 'soilAnalysesList',
    initialState,
    reducers: {
        getSoilPropertyD: (state, action: PayloadAction<soilAnalysesModel>) => {
            // console.log(action.payload);
            const newSoilProperty = [...state.soilPropertyList, ...action.payload.soilPropertyList];
            return {
                soilPropertyList: newSoilProperty,
                methodList: [...state.methodList],
                extList: [...state.extList],
                soilAnalysisList: [...state.soilAnalysisList]
            };
        },
        getMethodD: (state, action: PayloadAction<soilAnalysesModel>) => {
            const newMethod = [...state.methodList, ...action.payload.methodList];
            return {
                soilPropertyList: [...state.soilPropertyList],
                methodList: newMethod,
                extList: [...state.extList],
                soilAnalysisList: [...state.soilAnalysisList]
            };
        },
        getExtReferenctD: (state, action: PayloadAction<soilAnalysesModel>) => {
            const newExt = [...state.extList, ...action.payload.extList];
            return {
                soilPropertyList: [...state.soilPropertyList],
                methodList: [...state.methodList],
                extList: newExt,
                soilAnalysisList: [...state.soilAnalysisList]
            };
        },
        getSoilAnalysisList: (state, action: PayloadAction<any>) => {
            return {
                soilPropertyList: [...state.soilPropertyList],
                methodList: [...state.methodList],
                extList: [...state.extList],
                soilAnalysisList: action.payload
            };
        },
    }
});

export type {
    soilAnalysesModel
};

export const selectSoilPropertyList = (state: RootState) => state.soilAnalysesData;
export default soilAnalyses.reducer;

